import { memo, useEffect } from 'react'

import { Button, Group, Stack, Text } from '@mantine/core'

import { useAuth, useRequestConfirmEmail } from '@repo/common/queries/auth'

import { EmailConfirm } from '@/components/EmailConfirm'
import type { BasePanelProps } from '@/flows/flow_helpers'

export const PanelConfirmEmail = memo<BasePanelProps>(
  function PanelConfirmEmail({ onCompleted }) {
    const { data } = useAuth()
    const { mutate: resendEmail, isPending } = useRequestConfirmEmail()

    useEffect(() => {
      if (data?.is_email_confirmed) {
        onCompleted()
      }
    }, [data?.is_email_confirmed, onCompleted])

    useEffect(() => {
      resendEmail()
      // only call once
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (data?.uuid == null || data?.uuid == '') return null

    return (
      <Stack>
        <EmailConfirm uuid={data.uuid} without_header>
          <Group>
            <Text>
              An email has been sent to &quot;{data.email}&quot; with your
              confirmation code
            </Text>
          </Group>
        </EmailConfirm>
        <Group justify="flex-end">
          <Button
            size="sm"
            variant="outline"
            onClick={() => resendEmail()}
            loading={isPending}
          >
            Resend Email
          </Button>
        </Group>
      </Stack>
    )
  },
)

export const useSkipConfirmEmail = () => {
  const { data } = useAuth()
  return Boolean(data?.is_email_confirmed)
}
